import { render } from "./DispenserGuides.vue?vue&type=template&id=574d22fe"
import script from "./DispenserGuides.vue?vue&type=script&lang=js"
export * from "./DispenserGuides.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/DispenserGuides.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "574d22fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('574d22fe', __exports__)) {
    api.reload('574d22fe', __exports__)
  }
  
  module.hot.accept("./DispenserGuides.vue?vue&type=template&id=574d22fe", () => {
    api.rerender('574d22fe', render)
  })

}


export default __exports__